import React, { useEffect, useState } from "react";
import { DialogBox } from "../../../../../components/Elements/DialogBox";
import { Select } from "antd";
import CustomButton from "../../../../../components/Elements/Buttons/CustomButtons";

const UserFilter = ({ onOpen, onClose, setFilterData, initialFilter }) => {
  const [status, setStatus] = useState("");
  const [role, setRole] = useState("");

  useEffect(() => {
    if (onOpen) {
      // If `initialFilter` is an object but missing a key, that means the user selected 'All'
      if (initialFilter && typeof initialFilter === "object") {
        setStatus(
          Object.prototype.hasOwnProperty.call(initialFilter, "status")
            ? initialFilter.status
            : "All",
        );
        setRole(
          Object.prototype.hasOwnProperty.call(initialFilter, "role")
            ? initialFilter.role
            : "All",
        );
      } else {
        setStatus("");
        setRole("");
      }
    }
  }, [onOpen, initialFilter]);

  const handleSave = () => {
    const payload = {};
    if (status && status !== "All") payload.status = status;
    if (role && role !== "All") payload.role = role;
    setFilterData(payload);
    onClose();
  };

  const handleCancel = () => {
    setFilterData({ status: "", role: "" });
    setStatus("");
    setRole("");
    onClose();
  };

  return (
    <div>
      <DialogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="700px">
        <div>
          <h3 className="text-xl">Filter</h3>
        </div>
        <div
          style={{
            border: "1px solid #ebedf3",
            borderRadius: "10px",
            padding: "10px",
          }}
        >
          <div className="mx-10">
            <Select
              value={status || undefined}
              onChange={(val) => setStatus(val)}
              placeholder="Status"
              className="text-lg font-light h-14 w-full my-10"
              allowClear
              options={[
                { label: "All", value: "All" },
                { label: "Active", value: "Active" },
                { label: "Inactive", value: "Inactive" },
              ]}
            />
          </div>
          <div className="mx-10">
            <Select
              value={role || undefined}
              onChange={(val) => setRole(val)}
              placeholder="Role"
              className="text-lg font-light h-14 w-full my-2"
              allowClear
              options={[
                { label: "All", value: "All" },
                { value: "employee", label: "Employee" },
                { value: "vendor", label: "Vendor" },
                { value: "user", label: "User" },
              ]}
            />
          </div>
          <div className="flex justify-center gap-6 p-5">
            <CustomButton
              buttonType="button"
              variant="cancel"
              buttonText="Reset"
              onClick={handleCancel}
              className="text-base font-normal h-[50px] w-[160px]"
            />

            <CustomButton
              buttonType="button"
              variant="ok"
              buttonText="Search"
              onClick={handleSave}
              className="text-base font-normal h-[50px] w-[160px]"
            />
          </div>
        </div>
      </DialogBox>
    </div>
  );
};

export default UserFilter;
